import type { ViewerTreeNode } from "@/types/user-data-viewer";

export interface TreeNode extends ViewerTreeNode {
  children: TreeNode[];
}

export function buildTree(nodes: ViewerTreeNode[]): TreeNode[] {
  const byId = new Map<string, TreeNode>();
  for (const node of nodes) {
    byId.set(node.id, { ...node, children: [] });
  }

  const roots: TreeNode[] = [];
  for (const node of byId.values()) {
    const parent = node.parentId ? byId.get(node.parentId) : undefined;
    if (parent) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  }

  const sortRecursively = (list: TreeNode[]): void => {
    list.sort((a, b) => a.order - b.order);
    for (const node of list) {
      sortRecursively(node.children);
    }
  };
  sortRecursively(roots);

  return roots;
}
